import { jsx as _jsx } from "react/jsx-runtime";
import { ChartCard } from "../../../components/ui/ChartCard";
export function ChartFrame({ title, subtitle, children }) {
    return (_jsx(ChartCard, { title: title, subtitle: subtitle, header: "compact", children: children }));
}
